import { getGlobals, getArchive } from "storyblok/api"
import Meta from "components/Meta"
import { getArchiveBooks } from "storyblok/books"
import SimpleArchiveSection from "components/Archive/SimpleArchiveSection"
import BookCard from "components/BookCard"
import DynamicComponent from "components/DynamicComponent"
import ArchiveHeader from "components/Archive/ArchiveHeader"
import { CardListSection } from "components/Archive/CardListSection"
import { getArchiveBooksApi } from "storyblok/booksApi"

export default function BookArchive({ meta, story, items, perPage, total, currentPage }) {
  return (
    <>
      <Meta info={meta} />
      <main data-pagefind-body>
        <ArchiveHeader story={story?.content} breadcrumbs={[{ text: "Free Injury Law Guides", href: "/books" }]} />
        {story?.content?.body?.map((blok) => (
          <DynamicComponent blok={blok} key={blok._uid} />
        ))}
        <SimpleArchiveSection
          list={
            <CardListSection
              items={items}
              total={total}
              perPage={perPage}
              currentPage={currentPage}
              columns={3}
              backgroundColor="highlight-tint"
              handler={(params) => getArchiveBooksApi(params)}
              Card={BookCard}
            />
          }
        />
      </main>
    </>
  )
}

export async function getStaticProps({ preview = null }) {
  const globals = await getGlobals()

  const story = await getArchive("books", preview)

  const { items, currentPage, total, perPage } = await getArchiveBooks()

  return {
    props: {
      story: story ?? null,
      meta: story?.content?.twentysixty_seo ?? null,
      items,
      currentPage,
      total,
      perPage,
      globals: globals ?? null,
      preview,
    },
  }
}
